<template style="background-color: white;">
    <div class="div" style="background-color: white;">
        <!-- {{ person_details }} -->
        <div class="container" style="background-color: white;">
            <div style="display: flex;" v-if="person_details.rep_header != null">
                <div style="width: 30%; float: left;">
                    <img :src="person_details.rep_header.school_logo" style="width: 150px;" alt="logo" /><br />
                    <h6>SBPPS/ADM-D-03/Rev:01/Dt: 11.12.2025</h6>
                </div>

                <div style="width: 65%; float: left; text-align: center;">
                    <h3 style="text-transform: uppercase;">
                        {{ person_details.rep_header.trust_name }}
                    </h3>
                    <h1 style="text-transform: uppercase;">
                        {{ person_details.rep_header.school_name }}
                    </h1>
                    <h4 style="text-transform: uppercase;">CBSE Affiliated (Affiliation No.:1130534)</h4>
                    <h4 style="text-transform: uppercase;">NABET Accredited (certificate No.: WS 2428071)</h4>
                    <!-- <h4 style="text-transform: uppercase;">British Council IDS Certified (certification period.: 2020-23)</h4> -->
                    <h4 style="text-transform: uppercase;">QS I-Gauge Diamond Rated</h4>
                    <h5 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                        {{ person_details.rep_header.address }}
                    </h5>
                    <div style="font-weight: bold;">
                        <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                        <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email
                            }}</span><br />
                        <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                    </div>
                </div>
                <div style="width: 20%; float: right;">
                    <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
                </div>
            </div>
            <div align="center">
                <br />
                <h2>Admission Application Form</h2>
                <h3>(A.Y. {{ person_details.ay }})</h3>
            </div>
            <div style="margin-top: -60px; border: 2px solid #000; width: 150px; height: 150px; float: right;">
                <center>
                    <v-img width="120" :src="awspath +
                        person_details.profile_image_path +
                        person_details.profile_image_name
                        " aspect-ratio="1" class="lighten-2 mt-2" style="border: 1px solid black;"></v-img>
                </center>
            </div>
            <br />
            <br />
            <br />
            <br />

            <!-- <v-row justify="center">
                <div class="row" style="margin-top:-10px">
                    <div class="col-4">
                      <div class="row">  Form No: <h3 class="pl-4 stud_details2" style="margin: 10px; white-space: nowrap;width: 30%;">&nbsp;{{ person_details.admission_form_no }}</h3></div>
                    </div>
                    <div class="col-4">
                        <h3 style="margin: 10px; white-space: nowrap;">PRN(For Office Use):&nbsp;___________</h3>
                    </div>
                    <div class="col-4">
                        <h3 style="margin: 10px; white-space: nowrap;">GR NO(For Office Use):&nbsp;___________</h3>
                    </div>
                </div>
            </v-row> -->
            <div class="container" style="margin-top: -30px;">
                <div class="row">
                    <div class="col-3" style="">
                        <div class="row pl-2">
                            <b>Form No.: </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2">{{
                                person_details.display_admission_form_no }}</div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> PRN (For Office Use): </b>
                            <div style="width: 40%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> GR No. (For Office Use): </b>
                            <div style="width: 40%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <table style="border-collapse: collapse; width: 100%;">

                <body>
                    <tr>
                        <th style="width: 100%;" colspan="2" v-if="person_details.firstname != null"><b>Child's Name:
                                Miss/Master[First Name]</b></th>
                        <th colspan="4" v-if="person_details.middlename != null"><b>Middle Name</b></th>
                        <th colspan="8" v-if="person_details.lastname != null"><b>Last Name</b></th>
                    </tr>
                    <tr>
                        <td colspan="2" v-if="person_details.firstname != null">{{ person_details.firstname.field_value
                            }}</td>
                        <td colspan="4" v-if="person_details.middlename != null">{{
                            person_details.middlename.field_value }}</td>
                        <td colspan="8" v-if="person_details.lastname != null">{{ person_details.lastname.field_value }}
                        </td>
                    </tr>

                    <tr>
                        <td colspan="2">
                            <span v-if="person_details.date_of_birth != null">
                                <b>{{ person_details.date_of_birth.field_display_name }}: </b>
                                {{ person_details.date_of_birth.field_value }}
                            </span>
                            <span v-if="person_details.date_of_birth_in_words != null"> <b> Date Of Birth In Words:
                                </b>{{ person_details.date_of_birth_in_words.field_value }}</span>
                        </td>
                        <td colspan="8" v-if="person_details.standard != null">
                            <b>{{ person_details.standard.field_display_name }}: </b>
                            {{ person_details.standard.field_value }}
                        </td>
                    </tr>

                    <tr>
                        <td v-if="person_details.birth_place != null" colspan="2"><b> {{
                            person_details.birth_place.field_display_name }}: </b> {{
                                    person_details.birth_place.field_value }}</td>
                        <td v-if="person_details.nationality != null" colspan="8"><b> {{
                            person_details.nationality.field_display_name }}: </b> {{
                                    person_details.nationality.field_value }}</td>
                    </tr>
                    <tr>
                        <td colspan="2" v-if="person_details.gender != null">
                            <b>{{ person_details.gender.field_display_name }}: </b>
                            {{ person_details.gender.field_value }}
                        </td>
                        <td colspan="8" v-if="person_details.bloodgroup != null">
                            <b>{{ person_details.bloodgroup.field_display_name }}: </b>
                            {{ person_details.bloodgroup.field_value }}
                        </td>
                    </tr>

                    <tr>
                        <td colspan="2" v-if="person_details.family_type != null">
                            <b>{{ person_details.family_type.field_display_name }}: </b>
                            {{ person_details.family_type.field_value }}
                        </td>
                        <!-- <td  colspan="8"><b>Grade Applying For:</b></td> -->
                        <td colspan="8">
                            <span v-if="person_details.aadhar_no != null"><b>
                                    {{ person_details.aadhar_no.field_display_name }}: </b>{{
                                        person_details.aadhar_no.field_value }}</span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" v-if="person_details.languages_known != null">
                            <b> {{ person_details.languages_known.field_display_name }}: </b>
                            <!-- {{ person_details.languages_known.field_value }} -->
                            <span v-if="person_details.languages_known.field_value"
                                v-for="value in person_details.languages_known.field_value" :key="value">
                                {{ value }}
                            </span>
                        </td>
                        <td colspan="8" v-if="person_details.identification_mark_on_body != null">
                            <b>{{ person_details.identification_mark_on_body.field_display_name }}: </b>
                            {{ person_details.identification_mark_on_body.field_value }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2" v-if="person_details.mothertoungue != null">
                            <b>{{ person_details.mothertoungue.field_display_name }}: </b>
                            {{ person_details.mothertoungue.field_value }}
                        </td>
                        <td colspan="2" v-if="person_details.religion != null">
                            <b>{{ person_details.religion.field_display_name }}: </b>
                            {{ person_details.religion.field_value }}
                        </td>
                        <td colspan="2" v-if="person_details.cast != null">
                            <b>{{ person_details.cast.field_display_name }}: </b>
                            {{ person_details.cast.field_value }}
                        </td>
                        <td colspan="2" v-if="person_details.category != null">
                            <b>{{ person_details.category.field_display_name }}: </b>
                            {{ person_details.category.field_value }}
                        </td>
                    </tr>
                    <tr>
                        <td colspan="8">
                            <b>Current Residential Address: </b>
                            <span v-if="person_details.local_address.laddress"> {{ person_details.local_address.laddress
                                }} </span>
                        </td>
                    </tr>
                    <tr>
                        <td colspan="2"><b> Country: </b>{{ person_details.local_address.lcountry }}</td>

                        <td colspan="8"><b> State: </b>{{ person_details.local_address.lstate }}</td>
                    </tr>
                    <tr>
                        <td colspan="2"><b> City: </b>{{ person_details.local_address.lcity }}</td>

                        <td colspan="8"><b> Pin Code: </b>{{ person_details.local_address.lpin }}</td>
                        <!-- <td colspan="8"><b> Tel No:</b>{{ person_details.mobile_no }}</td> -->
                    </tr>
                    <tr>
                        <td colspan="8" v-if="person_details.nearest_landmark != null"><b>{{
                            person_details.nearest_landmark.field_display_name }}: </b>{{
                                    person_details.nearest_landmark.field_value }}</td>
                    </tr>
                    <tr>
                        <td colspan="8" v-if="person_details.special_education_needs != null"><b>{{
                            person_details.special_education_needs.field_display_name }}: </b>{{
                                    person_details.special_education_needs.field_value }}</td>
                    </tr>
                </body>
            </table>
            <!-- mother details -->
            <div>
                <center><b style="font-size: 16px; text-transform: uppercase;"> Parent's Information </b></center>
                <div style="display: flex;">
                    <table style="border-collapse: collapse; width: 100%;">

                        <body>
                            <tr v-if="person_details.relative_mother_details != null">
                                <td style="width: 100%;" colspan="8"><b>Mother's Name: </b> {{
                                    person_details.relative_mother_details.relative_full_name }}</td>
                            </tr>
                            <tr v-if="person_details.relative_mother_details != null">
                                <td colspan="8"><b>Educational and Professional Qualification: </b> {{
                                    person_details.relative_mother_details.relative_education }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" v-if="person_details.relative_mother_details != null">
                                    <b>Occupation: </b>
                                    {{ person_details.relative_mother_details.relative_occupation }}
                                </td>
                                <td colspan="2" v-if="person_details.relative_mother_details != null">
                                    <b>Designation: </b>
                                    {{ person_details.relative_mother_details.relative_designation }}
                                </td>
                                <td colspan="8" v-if="person_details.relative_mother_details != null">
                                    <b>Department: </b>
                                    {{ person_details.relative_mother_details.relative_department }}
                                </td>
                            </tr>
                            <tr v-if="person_details.relative_mother_details != null" style="white-space: pre-line;">
                                <td colspan="8"><b>Office Address: </b>
                                    {{ person_details.relative_mother_details.relative_office_address }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" v-if="person_details.relative_mother_details != null">
                                    <b>Company/Organization: </b>
                                    {{ person_details.relative_mother_details.relative_organization_name }}
                                </td>
                                <td colspan="8" v-if="person_details.relative_mother_details != null">
                                    <b>Mobile Number: </b>
                                    {{ person_details.relative_mother_details.relative_contact_no }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" v-if="person_details.relative_mother_details != null">
                                    <b>Email ID: </b>
                                    {{ person_details.relative_mother_details.relative_email }}
                                </td>
                                <td colspan="8" v-if="person_details.relative_mother_details != null">
                                    <b>Gross Annual Income: </b>
                                    {{ person_details.relative_mother_details.relative_income_range }}
                                </td>
                            </tr>
                        </body>
                    </table>
                    <div style="width: 33.33%; display: flex; justify-content: flex-end; align-items: center;">
                        <v-img :src="awspath + person_details.mother_photo" aspect-ratio="1" class="lighten-2"
                            style="width: 100%; max-width: 150px; border: 1px solid black;"></v-img>
                    </div>
                </div>
            </div>
            <br />
            <!-- ---------  father details----- -->
            <div>
                <div style="display: flex;">
                    <table style="border-collapse: collapse; width: 100%;">

                        <body>
                            <tr v-if="person_details.relative_father_details != null">
                                <td style="width: 100%;" colspan="8"><b>Father's Name: </b> {{
                                    person_details.relative_father_details.relative_full_name }}</td>
                            </tr>
                            <tr v-if="person_details.relative_father_details != null">
                                <td colspan="8"><b>Educational and Professional Qualification: </b> {{
                                    person_details.relative_father_details.relative_education }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" v-if="person_details.relative_father_details != null">
                                    <b>Occupation: </b>
                                    {{ person_details.relative_father_details.relative_occupation }}
                                </td>
                                <td colspan="2" v-if="person_details.relative_father_details != null">
                                    <b>Designation: </b>
                                    {{ person_details.relative_father_details.relative_designation }}
                                </td>
                                <td colspan="8" v-if="person_details.relative_father_details != null">
                                    <b>Department: </b>
                                    {{ person_details.relative_father_details.relative_department }}
                                </td>
                            </tr>
                            <tr v-if="person_details.relative_father_details != null" style="white-space: pre-line;">
                                <td colspan="8"><b>Office Address: </b>
                                    {{ person_details.relative_father_details.relative_office_address }}</td>
                            </tr>
                            <tr>
                                <td colspan="2" v-if="person_details.relative_father_details != null">
                                    <b>Company/Organization: </b>
                                    {{ person_details.relative_father_details.relative_organization_name }}
                                </td>
                                <td colspan="8" v-if="person_details.relative_father_details != null">
                                    <b>Mobile Number: </b>
                                    {{ person_details.relative_father_details.relative_contact_no }}
                                </td>
                            </tr>
                            <tr>
                                <td colspan="2" v-if="person_details.relative_father_details != null">
                                    <b>Email ID: </b>
                                    {{ person_details.relative_father_details.relative_email }}
                                </td>
                                <td colspan="8" v-if="person_details.relative_father_details != null">
                                    <b>Gross Annual Income: </b>
                                    {{ person_details.relative_father_details.relative_income_range }}
                                </td>
                            </tr>
                        </body>
                    </table>
                    <div style="width: 33.33%; display: flex; justify-content: flex-end; align-items: center;">
                        <v-img :src="awspath + person_details.father_photo" aspect-ratio="1" class="lighten-2"
                            style="width: 100%; max-width: 150px; border: 1px solid black;"></v-img>
                    </div>
                </div>
            </div>
            <br />
            <!-- gurdian details -->
            <div class="guardian details">
                <div style="display: flex;">
                    <table style="border-collapse: collapse; width: 100%;">

                        <body>
                            <tr>
                                <td style="width: 100%;" colspan="4">
                                    <span v-if="person_details.guardian_name_sbpps != null"><b>{{
                                        person_details.guardian_name_sbpps.field_display_name }}:
                                        </b>{{ person_details.guardian_name_sbpps.field_value }}</span>
                                </td>
                                <td colspan="8">
                                    <span v-if="person_details.guardian_relation_sbpps != null"><b>{{
                                        person_details.guardian_relation_sbpps.field_display_name }}:
                                        </b>{{ person_details.guardian_relation_sbpps.field_value }}</span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8">
                                    <b>
                                        <span v-if="person_details.guardian_contact_sbpps != null">
                                            {{ person_details.guardian_contact_sbpps.field_display_name }}
                                        </span>
                                        :
                                    </b>
                                    <span v-if="person_details.guardian_contact_sbpps != null">
                                        {{ person_details.guardian_contact_sbpps.field_value }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8">
                                    <span v-if="person_details.guardian_email_sbpps != null">
                                        <b> {{ person_details.guardian_email_sbpps.field_display_name }}: </b>
                                    </span>
                                    <!-- <b>Email id: </b> -->
                                    <span v-if="person_details.guardian_email_sbpps != null">
                                        {{ person_details.guardian_email_sbpps.field_value }}
                                    </span>
                                </td>
                            </tr>
                            <tr>
                                <td colspan="8" style="white-space: pre-line;">
                                    <b>
                                        <span v-if="person_details.guardian_address_sbpps != null">
                                            {{ person_details.guardian_address_sbpps.field_display_name }}
                                        </span>
                                        :
                                    </b>
                                    <span v-if="person_details.guardian_address_sbpps != null">
                                        {{ person_details.guardian_address_sbpps.field_value }}
                                    </span>
                                </td>
                            </tr>
                        </body>
                    </table>
                    <!-- {{ awspath + person_details.guardian_photo }} -->
                    <div style="width: 33.33%; display: flex; justify-content: flex-end; align-items: center;">
                        <v-img :src="awspath + person_details.guardian_photo1" aspect-ratio="1" class="lighten-2"
                            style="width: 100%; max-width: 150px; border: 1px solid black;"></v-img>
                    </div>
                </div>
            </div>
            <!-- declaration -->
            <!-- Siblings Details -->
        </div>
        <div class="container pagebreak">
            <br />
            <div>
                <center><b style="font-size: 22px; text-transform: uppercase;"> Sibling-1 Details </b></center>
                <table style="border-collapse: collapse; width: 100%;">
                    <!-- <caption>
                        <b style="font-size: 22px; text-transform: uppercase;">  </b>
                    </caption> -->

                    <body>
                        <tr v-if="person_details.sibling1 != null">
                            <td style="width: 100%;" colspan="2">
                                <b>Name: </b>
                                {{ person_details.sibling1.sibling_name }}
                            </td>
                            <td colspan="4">
                                <b>School Name: </b>
                                {{ person_details.sibling1.name_of_school }}
                            </td>
                            <td colspan="8">
                                <b>DOB: </b>
                                {{ person_details.sibling1.date_of_birth }}
                            </td>
                        </tr>
                        <tr v-if="person_details.sibling1 != null">
                            <td colspan="2">
                                <b>Relationship With Child: </b>
                                {{ person_details.sibling1.relationtype }}
                            </td>
                            <td colspan="8">
                                <b>Grade</b>
                                {{ person_details.sibling1.standard }}
                            </td>
                        </tr>
                    </body>
                </table>
            </div>
            <!-- <br /> -->
            <div v-if="person_details.sibling2">
                <center><b style="font-size: 22px; text-transform: uppercase;"> Sibling-2 Details </b></center>
                <table style="border-collapse: collapse; width: 100%;">
                    <!-- <caption>
                        <b style="font-size: 22px; text-transform: uppercase;">  </b>
                    </caption> -->

                    <body>
                        <tr v-if="person_details.sibling2 != null">
                            <td style="width: 100%;" colspan="2">
                                <b>Name: </b>
                                {{ person_details.sibling2.sibling_name }}
                            </td>
                            <td colspan="4">
                                <b>School Name: </b>
                                {{ person_details.sibling2.name_of_school }}
                            </td>
                            <td colspan="8">
                                <b>DOB: </b>
                                {{ person_details.sibling2.date_of_birth }}
                            </td>
                        </tr>
                        <tr v-if="person_details.sibling2 != null">
                            <td colspan="2">
                                <b>Relationship With Child: </b>
                                {{ person_details.sibling2.relationtype }}
                            </td>
                            <td colspan="8">
                                <b>Grade</b>
                                {{ person_details.sibling2.standard }}
                            </td>
                        </tr>
                    </body>
                </table>
            </div>

            <div>
                <center><b style="font-size: 22px; text-transform: uppercase;"> Previous School Attended </b></center>
                <table style="border-collapse: collapse; width: 100%;">
                    <!-- <caption>
                    <b style="font-size: 22px; text-transform: uppercase;"> Previous School Attended </b>
                </caption> -->

                    <body>
                        <tr>
                            <td v-if="person_details.previous_school_name != null" style="width: 100%;" colspan="2">
                                <b>{{ person_details.previous_school_name.field_display_name }}: </b> {{
                                    person_details.previous_school_name.field_value }}
                            </td>
                            <td v-if="person_details.previousschoolpassingstandard != null" colspan="8">
                                <b>{{ person_details.previousschoolpassingstandard.field_display_name }}: </b> {{
                                    person_details.previousschoolpassingstandard.field_value }}
                            </td>
                        </tr>
                        <tr>
                            <td v-if="person_details.previousschoolschoolboard != null" colspan="2">
                                <b>{{ person_details.previousschoolschoolboard.field_display_name }}: </b> {{
                                    person_details.previousschoolschoolboard.field_value }}
                            </td>
                            <td v-if="person_details.previous_school_obtained_percentage_new != null" colspan="8">
                                <b>{{ person_details.previous_school_obtained_percentage_new.field_display_name }}: </b>
                                {{ person_details.previous_school_obtained_percentage_new.field_value }}
                            </td>
                        </tr>
                        <tr v-if="person_details.reason_for_leaving_last_school != null">
                            <td colspan="8"><b>{{ person_details.reason_for_leaving_last_school.field_display_name }}:
                                </b> {{ person_details.reason_for_leaving_last_school.field_value }}</td>
                        </tr>
                    </body>
                </table>
            </div>

            <div class="row" style="margin-top: -2px;">
                <div class="col-12" v-if="person_details.admission_declaration != ''">
                    <span v-html="person_details.admission_declaration"></span>
                </div>
            </div>
            <div class="row" style="margin-top: -20px;">
                <div class="col-9" style=""></div>
                <div class="col-3" style="">
                    <div class="row">
                        <b>Date: </b>
                        <div style="width: 80%; margin-left: 5px;" class="stud_details2"></div>
                    </div>
                </div>
            </div>
            <br />
            <div class="container" style="margin-top: -60px;">
                <div class="row">
                    <div class="col-4" style="">
                        <div class="row pl-2">
                            <b> Father's Sign: </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> Mother's Sign: </b>
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> Guardian's Sign: </b>
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                </div>
            </div>
            <br />
            <div class="container" style="margin-top: -25px;">
                <h2 style="text-transform: uppercase; text-align: center;">For Office Use</h2>

                <div class="row" style="margin-top: -6px;">
                    <div class="col-4" style="">
                        <div class="row pl-2">
                            <b> Submission Date of Form: </b>
                            <div style="width: 30%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> Admission for Grade: </b>
                            <div style="width: 40%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> Signature: </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="container">
                <center>
                    <h2 style="text-transform: uppercase;">acceptance of application</h2>
                </center>
                <div class="row" style="border: #000 1px solid;">
                    <div class="col-4" style="">
                        <div class="row pl-2">
                            <b> Signature of Principal: </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-5" style=""></div>
                    <div class="col-3" style="">
                        <div class="row">
                            <b> Date: </b>
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container pagebreak" style="background-color: white;">
            <br />
            <div style="display: flex;" v-if="person_details.rep_header != null">
                <div style="width: 30%; float: left;">
                    <img :src="person_details.rep_header.school_logo" style="width: 150px;" alt="logo" /><br />
                    <h6>SBPPS/ADM-D-07/Rev:01/Dt: 11.12.2025</h6>
                </div>

                <div style="width: 65%; float: left; text-align: center;">
                    <h3 style="text-transform: uppercase;">
                        {{ person_details.rep_header.trust_name }}
                    </h3>
                    <h1 style="text-transform: uppercase;">
                        {{ person_details.rep_header.school_name }}
                    </h1>
                    <h4 style="text-transform: uppercase;">CBSE Affiliated (Affiliation No.:1130534)</h4>
                    <h4 style="text-transform: uppercase;">NABET Accredited (certificate No.: WS 2428071)</h4>
                    <!-- <h4 style="text-transform: uppercase;">British Council IDS Certified (certification period.: 2020-23)</h4> -->
                    <h4 style="text-transform: uppercase;">QS I-Gauge Diamond Rated</h4>
                    <h5 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                        {{ person_details.rep_header.address }}
                    </h5>
                    <div style="font-weight: bold;">
                        <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                        <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email
                            }}</span><br />
                        <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                    </div>
                </div>
                <div style="width: 20%; float: right;">
                    <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
                </div>
            </div>
            <div align="center">
                <br />
                <h2>Health Information Form</h2>
                <h3>(A.Y. {{ person_details.ay }})</h3>
            </div>
            <div class="container">
                <div class="row" style="border: #000 1px solid;">
                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row pl-2">
                            <b> Name of the Child: </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.firstname.field_value }} {{ person_details.middlename.field_value }}
                                {{ person_details.lastname.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row" v-if="person_details.standard != null">
                            <b> {{ person_details.standard.field_display_name }}: </b>
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2">{{
                                person_details.standard.field_value }}</div>
                        </div>
                    </div>
                    <!-- <div class="col-6" style="margin-top: -10px;">
                        <div class="row pl-2">
                            <b> Father/Relative Name: </b>
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_father_details.relative_full_name }}
                            </div>
                        </div>
                    </div> -->

                    <!-- <div class="col-6" style="margin-top: -10px;">
                        <div class="row">
                            <b> Contact No. : </b>
                            <div style="width: 72%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.relative_father_details.relative_contact_no }}
                            </div>
                        </div>
                    </div> -->

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row pl-2" v-if="person_details.family_doctor_name != null">
                            <b> {{ person_details.family_doctor_name.field_display_name }}: </b>
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.family_doctor_name != null">
                                {{ person_details.family_doctor_name.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row" v-if="person_details.family_doctor_contact != null">
                            <b> {{ person_details.family_doctor_contact.field_display_name }} : </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.family_doctor_contact != null">
                                {{ person_details.family_doctor_contact.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row pl-2" v-if="person_details.emergency_contact_name != null">
                            <b> {{ person_details.emergency_contact_name.field_display_name }}: </b>
                            <div style="width: 30%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.emergency_contact_name != null">
                                {{ person_details.emergency_contact_name.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row" v-if="person_details.emergency_contact_number != null">
                            <b> {{ person_details.emergency_contact_number.field_display_name }} : </b>
                            <div style="width: 25%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.emergency_contact_number != null">
                                {{ person_details.emergency_contact_number.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-4" style="margin-top: -10px;">
                        <div class="row pl-2" v-if="person_details.bloodgroup != null">
                            <b> {{ person_details.bloodgroup.field_display_name }}: </b>
                            <div style="width: 40%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.bloodgroup != null">
                                {{ person_details.bloodgroup.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-4" style="margin-top: -10px;">
                        <div class="row" v-if="person_details.height_in_cm != null">
                            <b> {{ person_details.height_in_cm.field_display_name }}: </b>
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.height_in_cm != null">
                                {{ person_details.height_in_cm.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-4" style="margin-top: -10px;">
                        <div v-if="person_details.weight_in_kg != null" class="row">
                            <b> {{ person_details.weight_in_kg.field_display_name }}: </b>
                            <div style="width: 55%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.weight_in_kg != null">
                                {{ person_details.weight_in_kg.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12" style="margin-top: -10px;">
                        <div v-if="person_details.medication != null" class="row pl-2">
                            <b> {{ person_details.medication.field_display_name }}: </b>
                            <div style="width: 65%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.medication != null">
                                {{ person_details.medication.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row pl-2" v-if="person_details.allergy != null">
                            <b> {{ person_details.allergy.field_display_name }}: </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.allergy != null">
                                {{ person_details.allergy.field_value }}
                            </div>
                        </div>
                    </div>
                    <div class="col-6" style="margin-top: -10px;">
                        <div v-if="person_details.identification_mark_on_body != null" class="row pl-2">
                            <b> {{ person_details.identification_mark_on_body.field_display_name }}: </b>
                            <div style="width: 55%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.allergy != null">
                                {{ person_details.identification_mark_on_body.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-12" style="margin-top: -10px;">
                        <div class="row pl-2" v-if="person_details.any_chronological_disease != null">
                            <b> {{ person_details.any_chronological_disease.field_display_name }}: </b>
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.any_chronological_disease != null">
                                {{ person_details.any_chronological_disease.field_value }}
                            </div>
                        </div>
                    </div>
                    <div class="col-12" style="margin-top: -10px;">
                        <div class="row pl-2" v-if="person_details.physical_activity_needs_to_avoid != null">
                            <b> {{ person_details.physical_activity_needs_to_avoid.field_display_name }}: </b>
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.physical_activity_needs_to_avoid != null">
                                {{ person_details.physical_activity_needs_to_avoid.field_value }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-12" v-if="person_details.medical_declaration_value != ''">
                        <span v-html="person_details.medical_declaration_value"></span>
                    </div>
                </div>
                <div style="margin-top: -30px;" class="row pl-3">
                    <div class="col-12" v-if="person_details.vacination != null">
                        <div class="row">
                            <span class="pr-5">The general vaccination of the child has been done.</span>
                            <strong>{{ person_details.vacination.field_value }}</strong>
                            <!-- <v-checkbox v-model="person_details.vacination.field_value" color="primary darken-1" :label="person_details.vacination ? 'Yes':'No'" readonly dense required></v-checkbox> -->
                        </div>
                    </div>
                    <div style="margin-top: -30px;" class="col-12">
                        <div class="row">
                            <span class="pr-5">I hereby verify that I have read, understood and accepted the statements
                                above.</span> <strong>Yes</strong>
                            <!-- <v-checkbox v-model="health_declration" color="primary darken-1" :label="health_declration ? 'Yes':'No'" readonly dense required></v-checkbox> -->
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="row">
                    <div class="col-5" style="">
                        <div class="row pl-2">
                            <b> Mother's/Father's Signature: </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-3" style="">
                        <div class="row">
                            <b> Date: </b>
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> Received By: </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container pagebreak" style="background-color: white;">
            <br />
            <div style="display: flex;" v-if="person_details.rep_header != null">
                <div style="width: 30%; float: left;">
                    <img :src="person_details.rep_header.school_logo" style="width: 150px;" alt="logo" /><br />
                </div>

                <div style="width: 65%; float: left; text-align: center;">
                    <h3 style="text-transform: uppercase;">
                        {{ person_details.rep_header.trust_name }}
                    </h3>
                    <h1 style="text-transform: uppercase;">
                        {{ person_details.rep_header.school_name }}
                    </h1>
                    <h4 style="text-transform: uppercase;">CBSE Affiliated (Affiliation No.:1130534)</h4>
                    <h4 style="text-transform: uppercase;">NABET Accredited (certificate No.: WS 2428071)</h4>
                    <!-- <h4 style="text-transform: uppercase;">British Council IDS Certified (certification period.: 2020-23)</h4> -->
                    <h4 style="text-transform: uppercase;">QS I-Gauge Diamond Rated</h4>
                    <h5 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                        {{ person_details.rep_header.address }}
                    </h5>
                    <div style="font-weight: bold;">
                        <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                        <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email
                            }}</span><br />
                        <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                    </div>
                </div>
                <div style="width: 20%; float: right;">
                    <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
                </div>
            </div>
            <div align="center">
                <br />
                <h2>Transport Form</h2>
                <h3>(A.Y. {{ person_details.ay }})</h3>
            </div>
            <div class="container">
                <div class="row" style="border: #000 1px solid;">
                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row pl-2">
                            <b> Name of the child: </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.firstname.field_value }} {{ person_details.middlename.field_value }}
                                {{ person_details.lastname.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row">
                            <b> Grade: </b>
                            <div v-if="person_details.standard != null" style="width: 80%; margin-left: 5px;"
                                class="stud_details2">{{ person_details.standard.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-12" style="margin-top: -35px;">
                        <div class="row pl-2">
                            <b> {{ person_details.is_transport_facility_needed.field_display_name }}: </b>
                            <!-- <v-checkbox style="margin-top: -8px;" class="pl-4" v-model="person_details.is_transport_facility_needed" color="primary darken-1" :label="person_details.is_transport_facility_needed ? 'Yes':'No'" readonly dense required></v-checkbox> -->
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.is_transport_facility_needed != null">
                                <span v-if="person_details.is_transport_facility_needed.field_value == 'Yes'"> Yes
                                </span>
                                <span v-else> No </span>
                            </div>
                        </div>
                    </div>

                    <div class="col-12" style="margin-top: -35px;"
                        v-if="person_details.is_transport_facility_needed != null">
                        <div class="row pl-2" v-if="person_details.is_transport_facility_needed.field_value == 'Yes'">
                            <b> Residenstial Address: </b>
                            <div style="width: 75%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.transport_resedential_address != null">
                                {{ person_details.transport_resedential_address.field_value }}
                            </div>
                        </div>
                    </div>
                    <!-- <div class="col-12" style="margin-top: -10px;" v-if="person_details.is_transport_facility_needed!=null">
                        <div class="row pl-2" v-if="person_details.is_transport_facility_needed.field_value=='Yes'">
                            <b> Link for bus route: </b>
                            <div style="width: 88%; margin-left: 5px;" class="stud_details2">
                                <a target="_blank" href="https://drive.google.com/file/d/1g8JAo5r9548Rj_GI3lTtyGEmoVZEDSOo/view?usp=sharing">
                                    https://drive.google.com/file/d/1g8JAo5r9548Rj_GI3lTtyGEmoVZEDSOo/view?usp=sharing
                                </a>
                            </div>
                        </div>
                    </div> -->
                    <div class="col-6" style="margin-top: -35px;"
                        v-if="person_details.is_transport_facility_needed != null">
                        <div class="row pl-2" v-if="person_details.is_transport_facility_needed.field_value == 'Yes'">
                            <b>{{ person_details.transport_boarding_point.field_display_name }}: </b>
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.transport_boarding_point != null">
                                {{ person_details.transport_boarding_point.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -35px;"
                        v-if="person_details.is_transport_facility_needed != null">
                        <div class="row"
                            v-if="person_details.is_transport_facility_needed.field_value == 'Yes' && person_details.transport_drop_point != null">
                            <b> {{ person_details.transport_drop_point.field_display_name }}: </b>
                            <div style="width: 65%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.transport_drop_point != null">
                                {{ person_details.transport_drop_point.field_value }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="font-size: 15px;" v-if="person_details.is_transport_facility_needed != null">
                    <div class="col-12"
                        v-if="person_details.defaultValues != null && person_details.is_transport_facility_needed.field_value == 'Yes'">
                        <span v-html="person_details.defaultValues"></span>
                    </div>
                </div>
            </div>
            <div class="container" style="margin-top: -70px;">
                <div class="row">
                    <div class="col-5" style="">
                        <div class="row pl-2">
                            <b> Mother's/Father's Signature: </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-3" style="">
                        <div class="row">
                            <b> Date: </b>
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> Received By: </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="container pagebreak" style="background-color: white;">
            <br />
            <div style="display: flex;" v-if="person_details.rep_header != null">
                <div style="width: 30%; float: left;">
                    <img :src="person_details.rep_header.school_logo" style="width: 150px;" alt="logo" /><br />
                </div>

                <div style="width: 65%; float: left; text-align: center;">
                    <h3 style="text-transform: uppercase;">
                        {{ person_details.rep_header.trust_name }}
                    </h3>
                    <h1 style="text-transform: uppercase;">
                        {{ person_details.rep_header.school_name }}
                    </h1>
                    <h4 style="text-transform: uppercase;">CBSE Affiliated (Affiliation No.:1130534)</h4>
                    <h4 style="text-transform: uppercase;">NABET Accredited (certificate No.: WS 2428071)</h4>
                    <!-- <h4 style="text-transform: uppercase;">British Council IDS Certified (certification period.: 2020-23)</h4> -->
                    <h4 style="text-transform: uppercase;">QS I-Gauge Diamond Rated</h4>
                    <h5 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                        {{ person_details.rep_header.address }}
                    </h5>
                    <div style="font-weight: bold;">
                        <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                        <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email
                            }}</span><br />
                        <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                    </div>
                </div>
                <div style="width: 20%; float: right;">
                    <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
                </div>
            </div>
            <div align="center">
                <br />
                <h2>Canteen Form</h2>
                <h3>(A.Y. {{ person_details.ay }})</h3>
            </div>
            <div class="container">
                <div class="row" style="border: #000 1px solid;">
                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row pl-2">
                            <b> Name of the child: </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2">
                                {{ person_details.firstname.field_value }} {{ person_details.middlename.field_value }}
                                {{ person_details.lastname.field_value }}
                            </div>
                        </div>
                    </div>

                    <div class="col-6" style="margin-top: -10px;">
                        <div class="row">
                            <b> Grade: </b>
                            <div v-if="person_details.standard != null" style="width: 80%; margin-left: 5px;"
                                class="stud_details2">{{ person_details.standard.field_value }}</div>
                        </div>
                    </div>
                    <div class="col-12" style="margin-top: -35px;">
                        <div class="row pl-2">
                            <b> {{ person_details.is_canteen_facility_needed.field_display_name }}: </b>
                            <!-- <v-checkbox style="margin-top: -8px;" class="pl-4" v-model="person_details.is_transport_facility_needed" color="primary darken-1" :label="person_details.is_transport_facility_needed ? 'Yes':'No'" readonly dense required></v-checkbox> -->
                            <div style="width: 60%; margin-left: 5px;" class="stud_details2"
                                v-if="person_details.is_canteen_facility_needed != null">
                                <span v-if="person_details.is_canteen_facility_needed.field_value == 'Yes'"> Yes </span>
                                <span v-else> No </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row" style="font-size: 15px;" v-if="person_details.is_canteen_facility_needed != null">
                        <div class="col-12"
                            v-if="person_details.defaultValuesCanteen != null && person_details.is_canteen_facility_needed.field_value == 'Yes'">
                            <span v-html="person_details.defaultValuesCanteen"></span>
                        </div>
                </div>                
            </div>
            <div class="container" style="margin-top: -70px;">
                <div class="row">
                    <div class="col-5" style="">
                        <div class="row pl-2">
                            <b> Mother's/Father's Signature: </b>
                            <div style="width: 50%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-3" style="">
                        <div class="row">
                            <b> Date: </b>
                            <div style="width: 80%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                    <div class="col-4" style="">
                        <div class="row">
                            <b> Received By: </b>
                            <div style="width: 70%; margin-left: 5px;" class="stud_details2"></div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <div v-if="person_details.registered_subjects.field_value && person_details.registered_subjects.field_value.length > 0" class="container pagebreak" style="background-color: white;">
            <br />
            <div style="display: flex;" v-if="person_details.rep_header != null">
                <div style="width: 30%; float: left;">
                    <img :src="person_details.rep_header.school_logo" style="width: 150px;" alt="logo" /><br />
                    <h6>SBPPS/ADM-D-06/Rev:00/Dt: 01.06.2023</h6>
                </div>

                <div style="width: 65%; float: left; text-align: center;">
                    <h3 style="text-transform: uppercase;">
                        {{ person_details.rep_header.trust_name }}
                    </h3>
                    <h1 style="text-transform: uppercase;">
                        {{ person_details.rep_header.school_name }}
                    </h1>
                    <h4 style="text-transform: uppercase;">CBSE Affiliated (Affiliation No.:1130534)</h4>
                    <h4 style="text-transform: uppercase;">NABET Accredited (certificate No.: WS1923071)</h4>
                    <!-- <h4 style="text-transform: uppercase;">British Council IDS Certified (certification period.: 2020-23)</h4> -->
                    <h4 style="text-transform: uppercase;">QS I-Gauge Diamond Rated</h4>
                    <h5 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                        {{ person_details.rep_header.address }}
                    </h5>
                    <div style="font-weight: bold;">
                        <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                        <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email
                            }}</span><br />
                        <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                    </div>
                </div>
                <div style="width: 20%; float: right;">
                    <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
                </div>
            </div>
            <div align="center">
                <br />
                <h2>Registered Subjects</h2>
                <h3>(A.Y. {{ person_details.ay }})</h3>
            </div>
            <div class="container">
                <table border="1" style="width: 100%; text-align: center; border-collapse: collapse;">
                    <thead>
                        <tr>
                        <th class="text-center">Sr.No.</th>
                        <th class="pl-3">Subject Name</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(subject, index) in filteredSubjects" :key="index" >
                        <td class="text-center">{{ index + 1 }}</td>
                        <td class="pl-3">{{ subject }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <div class="container pagebreak" style="background-color: white;">
            <br />
            <div style="display: flex;" v-if="person_details.rep_header != null">
                <div style="width: 30%; float: left;">
                    <img :src="person_details.rep_header.school_logo" style="width: 150px;" alt="logo" /><br />
                    <h6>SBPPS/ADM-D-03/Rev:00/Dt: 01.06.2023</h6>
                </div>

                <div style="width: 65%; float: left; text-align: center;">
                    <h3 style="text-transform: uppercase;">
                        {{ person_details.rep_header.trust_name }}
                    </h3>
                    <h1 style="text-transform: uppercase;">
                        {{ person_details.rep_header.school_name }}
                    </h1>
                    <h4 style="text-transform: uppercase;">CBSE Affiliated (Affiliation No.:1130534)</h4>
                    <h4 style="text-transform: uppercase;">NABET Accredited (certificate No.: WS 2428071)</h4>
                    <!-- <h4 style="text-transform: uppercase;">British Council IDS Certified (certification period.: 2020-23)</h4> -->
                    <h4 style="text-transform: uppercase;">QS I-Gauge Diamond Rated</h4>
                    <h5 style="text-transform: uppercase;" class="mdi mdi-map-marker">
                        {{ person_details.rep_header.address }}
                    </h5>
                    <div style="font-weight: bold;">
                        <span class="mdi mdi-web"> {{ person_details.rep_header.website }} </span>
                        <span class="mdi mdi-email" style="margin-left: 10%;"> {{ person_details.rep_header.email
                            }}</span><br />
                        <span class="mdi mdi-phone"> {{ person_details.rep_header.phone }} </span>
                    </div>
                </div>
                <div style="width: 20%; float: right;">
                    <img :src="person_details.rep_header.trust_logo" style="width: 150px;" alt="logo" />
                </div>
            </div>
            <v-row dense justify="center" v-if="document_list != ''">
                <div align="center">
                    <br />
                    <h2>Uploaded Documents</h2>
                    <h3>(A.Y. {{ person_details.ay }})</h3>
                </div>
                <v-col cols="10" sm="10" md="10">
                    <template>
                        <v-simple-table fixed-header>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">Document Name</th>
                                        <!-- 
                  <th class="text-left">Remark</th> -->
                                        <th class="text-left">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, i) in document_list" :key="i">
                                        <td>{{ item.documenttype }}</td>

                                        <!-- <td>{{ item.remark }}</td> -->
                                        <td>
                                            <v-btn text color="primary" icon title="download">
                                                <a :href="awspath + item.documentlink" target="_blank"
                                                    style="text-decoration: none;">
                                                    <v-icon>mdi-file-download</v-icon>
                                                </a>
                                            </v-btn>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </template>
                </v-col>
            </v-row>
            <v-row dense justify="center" v-else>
                <v-col cols="10" sm="10" md="10">
                    <v-alert icon="mdi-file-document-box-remove" prominent text type="error">
                        Not Uploaded any documents yet.
                    </v-alert>
                </v-col>
            </v-row>
        </div>
        <div class="container">
            <div class="text-center">
                <v-btn class="ma-2 no-display" tile outlined color="warning" @click="print()"
                    v-if="person_details != null">
                    <v-icon left>mdi-printer</v-icon>Print
                    <v-icon right></v-icon>
                </v-btn>
            </div>
            <!-- text-center -->
        </div>
    </div>
</template>

<script>
import axios from "axios";
import "@/assets/css/color.css"; // css needs to be imported for each dashboard
export default {
    data() {
        return {
            person_details: null,
            health_declration: true,
            document_list: [],
            user_type: null,
            //         frm:null,
        };
    },
    computed: {
  filteredSubjects() {
    return this.person_details.registered_subjects.field_value.filter(
      subject => subject.toLowerCase() !== 'na'
    );
  }
},
    // props: ["person_details"],
    created() {
        this.awspath = localStorage.getItem("awspath");
        this.tenant = localStorage.getItem("EPS-tenant");
        this.user_type = localStorage.getItem("EPS-ut");
    },
    mounted() {
        this.frm = localStorage.getItem("setform_id");
        this.current_academic_year = localStorage.getItem("setay");

        const data = {
            ay: this.current_academic_year,
            form_id: this.frm,
        };
        localStorage.setItem("admission-ay", this.current_academic_year);
        axios
            .post("/Admission/get_application_form", data)
            .then((res) => {
                console.log("res", res.data);
                if (res.data.status.code == "SUCCESS") {
                    this.person_details = res.data.person_details;
                    this.document_list = res.data.document_list;
                    // (document.getElementById("one_view_form").style.pointerEvents =
                    //   "none"),
                    console.log(this.person_details);
                    this.printForm(this.person_details);
                    this.print_toggle = false;
                } else {
                    console.log("Nah...");
                    this.person_details = null;
                    //error
                }
            })
            .catch((error) => {
                window.console.log(error);
            })
            .finally(() => {
                //close loader
            });
    },
    methods: {
        print() {
            setTimeout(function () {
                window.print();
            }, 100);
        },
    },
};
</script>

<style scoped>
.signature {
    float: left;
}

.signature {
    float: left;
}

tr,
td,
th {
    border: 1px solid #ccc;
    text-align: left;
    font-size: small;
}

tr,
body {
    border-bottom: 1px solid #ccc;
    border: 1px solid #ccc;
    font-size: small;
}

td {
    margin: 0.2rem !important;
    padding: 0.2rem !important;
    font-size: small;
}

@media (min-width: 320px) {

    td,
    th {
        display: table-cell !important;
        font-size: small;
    }

    td+td,
    th+th {
        width: auto;
        font-size: small;
    }
}

table {
    white-space: nowrap !important;
    text-align: center;
    font-size: small;
}

@media print {

    .no-display,
    input[type="button"],
    input[type="submit"],
    input[type="reset"],
    #v-card {
        display: none !important;
    }

    .textarea1 {
        background-color: red !important;
    }

    @page :first {
        margin-top: 5mm;
    }

    .pagebreak {
        page-break-before: always;
        padding-top: 5px !important;
    }

    @page {
        size: A4;
        margin-top: 0;
        padding-top: none;
        /* size: 15in 15.5in; */
        size: 11.5in 16.5in;
    }

    /* .div::before {
        content: "";
        position: fixed;
        top: 0px;
        left: 0;
        width: 100%;
        height: 100%;
        border: 2px solid black !important;
         
        }*/
}

.photo {
    margin: 10px;
    margin-top: 15px;
    margin-right: 15px;
    float: right;
    font-family: "Times New Roman";
}

div.row {
    margin-top: 15px;
    font-family: "Times New Roman";
}

.row1 {
    margin-top: 0px;
    font-family: "Times New Roman";
}

.stud_details {
    border-bottom: 1px solid black;
    height: 60px;
}

.stud_details1 {
    border-bottom: 1px solid black;
    height: 25px;
}

div.row {
    margin-top: 15px;
    font-family: "Times New Roman";
}

.row1 {
    margin-top: 0px;
    font-family: "Times New Roman";
}

.stud_details {
    border-bottom: 1px solid black;
    height: 60px;
}

.stud_details1 {
    border-bottom: 1px solid black;
    height: 25px;
}

.stud_details2 {
    border-bottom: 1px solid black;
    height: 25px;
}
</style>
